import React, { lazy } from "react";

const Login = lazy(() => import("./views/pages/user/Login.jsx"));
const Lock = lazy(() => import("./views/pages/user/Lock.jsx"));
//const Register  = lazy(() => import('./views/pages/user/Register.jsx'));
const Welcome = lazy(() => import("./views/pages/user/Welcome.jsx"));
const UserProfile = lazy(() => import("./views/pages/user/UserProfile.jsx"));
const ChangePassword = lazy(() => import("./views/pages/user/ChangePassword.jsx"));
const passwordreset = lazy(() => import("./views/pages/user/ChangePassword.jsx"));
//pages
const OperatorDash = lazy(() => import("./views/pages/partnerTools/OperatorDashboard.jsx"));
const Planning = lazy(() => import("./views/pages/planning/PatnerManagementLayout.jsx"));
const VowPlanning = lazy(() => import("./views/pages/planning/VowPlanningLayout.jsx"));
const QuarterlyReview = lazy(() => import("./views/pages/reporting/QuarterlyReview.jsx"));
const MultiWellPerformanceLayout = lazy(() => import("./views/pages/multiWellTools/segmentKPITools/MultiWellPerformanceLayout.jsx"));
const GoalReviewLayout = lazy(() => import("./views/pages/benchmarkAnalysis/rigRanking/GoalReviewLayout.jsx"));
const GoalLayout = lazy(() => import("./views/pages/goalmanagement/GoalLayout.jsx"));
const Engagement = lazy(() => import("./views/pages/animoUserEngagement/EngagementLayout.jsx"));
// const Jobs  = lazy(() => import('./views/pages/singleWell/drillingOperations/Well.jsx'));
const DrillingLayout = lazy(() => import("./views/pages/singleWell/drillingOperations/DrillingLayout.jsx"));
const RTFullScreen = lazy(() => import("./views/pages/parameterTools/RTFullScreen.jsx"));
const DigitalHubLayout = lazy(() => import("./views/pages/singleWell/drillingOperations/DigitalHubLayout.jsx"));
const MultiWellSearch = lazy(() => import("./views/pages/multiWellTools/search/MultiWellSearch.jsx"));
const RigPerformanceReport = lazy(() => import("./views/pages/reporting/RigPerformanceReport.jsx"));
const OpsLayout = lazy(() => import("./views/pages/operationsTools/OpsLayout.jsx"));
const OpsMonitoringHub = lazy(() => import("./views/pages/operationsTools/DataReview/OpsMonitoringHub.jsx"));
//const ParameterFeeds  = lazy(() => import('./views/pages/parameterTools/ParameterFeeds.jsx'));
// const RTViewer  = lazy(() => import('./views/pages/parameterTools/RTViewer_Highcharts.jsx'));
//const MotorShop  = lazy(() => import('./views/pages/motorshop/MotorShop.jsx'));
//const MWDShop  = lazy(() => import('./views/pages/mwdshop/MWDShop.jsx'));
const WellPlots = lazy(() => import("./views/pages/singleWell/drillingOperations/Wellplot.jsx"));
const Error = lazy(() => import("./views/pages/systemSupport/Error404.jsx"));
const Development = lazy(() => import("./views/pages/systemSupport/InDevelopment.jsx"));
const Reporting = lazy(() => import("./views/pages/singleWell/reporting/Reporting.jsx"));
const UserNotifications = lazy(() => import("./views/tables/users/UserNotificationTable.jsx"));
//const Help  = lazy(() => import('./views/pages/Help.jsx'));
//component pages
const PlanUpload = lazy(() => import("./views/forms/dataInjection/PlanUpload.jsx"));
//const DualFilter  = lazy(() => import('./views/components/dualfilter.jsx'));
const Listadd = lazy(() => import("./views/components/listadd.jsx"));
const Directional = lazy(() => import("./views/pages/singleWell/drillingOperations/Directional.jsx"));

//tables
const ScenarioPlanningTables = lazy(() => import("./views/tables/ScenarioPlanningTables.jsx"));
const BusinessPlanLayout = lazy(() => import("./views/tables/bpVSactual/BusinessPlanLayout.jsx"));
const AFEPlanningTables = lazy(() => import("./views/tables/AFEPlanningTables.jsx"));
const EventPlanningTables = lazy(() => import("./views/tables/EventPlanningTables.jsx"));
const EventScheduleTables = lazy(() => import("./views/tables/EventScheduleTables.jsx"));

const WellTables = lazy(() => import("./views/tables/WellTables.jsx"));
const ShipTable = lazy(() => import("./views/tables/assetTracking/ShipmentTables.jsx"));
const InventoryTable = lazy(() => import("./views/tables/assetTracking/InventoryTables.jsx"));
const InventoryDetails = lazy(() => import("./views/tables/InventoryDetails.jsx"));
const BidTable = lazy(() => import("./views/tables/BidTables.jsx"));
const BHATable = lazy(() => import("./views/tables/bhas/BHATables.jsx"));

const IntervalTable = lazy(() => import("./views/tables/IntervalTables.jsx"));
const UserManagement = lazy(() => import("./views/pages/user/UserManagementLayout.jsx"));
const CompanyManagement = lazy(() => import("./views/pages/partnerTools/CompanyManagementLayout.jsx"));

//Forms
const AddWell = lazy(() => import("./views/pages/singleWell/wellDetails/AddWell.jsx"));
const AddBHA = lazy(() => import("./views/pages/singleWell/wellDetails/AddBHA.jsx"));
const AddBid = lazy(() => import("./views/forms/bids/AddBid.jsx"));

const AddPersonJob = lazy(() => import("./views/pages/singleWell/wellDetails/AddPersonWell.jsx"));
const AddShip = lazy(() => import("./views/pages/downholeTools/Shipments/AddShipment.jsx"));
const AddInventory = lazy(() => import("./views/pages/downholeTools/AssetControls/AddInventory.jsx"));

//const AddSensorData  = lazy(() => import('./views/forms/AddSensorData.jsx'));
//const AddAlert  = lazy(() => import('./views/forms/AddAlerts.jsx'));

const EditWell = lazy(() => import("./views/pages/singleWell/wellDetails/EditWell.jsx"));
const EditInventory = lazy(() => import("./views/pages/downholeTools/AssetControls/EditInventory.jsx"));
const EditVendorInventory = lazy(() => import("./views/pages/downholeTools/AssetControls/EditVendorInventory.jsx"));
const EditBid = lazy(() => import("./views/forms/bids/EditBid.jsx"));
const EditBHA = lazy(() => import("./views/pages/singleWell/wellDetails/EditBHA.jsx"));
const EditShip = lazy(() => import("./views/pages/downholeTools/Shipments/EditShipment.jsx"));
//const RequestUser  = lazy(() => import('./views/pages/singleWell/wellDetails/UserRequest.jsx'));
const GoogleMaps = lazy(() => import("./views/maps/GoogleMaps.jsx"));
//Active Pages With Know Front end Route Connection
const MorningCall = lazy(() => import("./views/pages/morningCall/MorningCall.jsx"));

const routes = [
  {
    path: "welcome",
    name: "welcome",
    icon: "tim-icons icon-single-02",
    element: <Welcome />,
    layout: "/admin",
  },

  {
    path: "dailyCall/:jobId/:viewStyle?",
    name: "Daily Ops",
    minicon: "animo-icons icon-analytics-svgrepo-com",
    icon: "animo-icons icon-analytics-svgrepo-com",
    mini: "D0",
    element: <MorningCall />,
    layout: "/admin",
    doNotShowInSideber: false,
    doNotShowDirectional: true,
    doNotShow99: true,
    doNotShowThirds: true,
  },
  {
    path: "dailyCall/:jobId/",
    name: "Daily Ops",
    minicon: "animo-icons icon-analytics-svgrepo-com",
    icon: "animo-icons icon-analytics-svgrepo-com",
    mini: "D0",
    element: <MorningCall />,
    layout: "/admin",
    doNotShowInSideber: false,
    doNotShowDirectional: true,
    doNotShow99: true,
    doNotShowThirds: true,
  },
  {
    path: "dailyCall/",
    name: "Daily Ops",
    element: <MorningCall />,
    minicon: "animo-icons icon-analytics-svgrepo-com",
    icon: "animo-icons icon-analytics-svgrepo-com",
    layout: "/admin",
    doNotShowInSideber: false,
    doNotShowDirectional: true,
    doNotShow99: true,
    doNotShowThirds: true,
  },

  {
    path: "welllist",
    name: "Well Library",
    icon: "tim-icons icon-bullet-list-67",
    minicon: "tim-icons icon-bullet-list-67",
    mini: "M",
    element: <WellTables />,
    //doNotShowThirds: true,
    show99: true,
    doNotShowMorningCallUser: true,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Single Well",
    minicon: "animo-icons icon-focus",
    icon: "animo-icons icon-focus",
    state: "SingleWellCollapse",
    doNotShow99: true,
    doNotShowMorningCallUser: true,
    children: [
      {
        path: "activewell",
        name: "Well Analytics",
        minicon: "animo-icons icon-segment-results",
        element: <DrillingLayout />,
        layout: "/admin",
        NeedActiveJob: true,
        doNotShowMorningCallUser: true,
      },

      {
        path: "digitalHub",
        name: "Digital Hub",
        minicon: "animo-icons icon-blockchain",
        element: <DigitalHubLayout />,
        layout: "/admin",
        NeedActiveJob: true,
        doNotShowMorningCallUser: true,
      },
    ],
  },

  {
    collapse: true,
    name: "Inventory",
    icon: "tim-icons icon-molecule-40",
    state: "inventoryCollapse",
    doNotShowOperator: true,
    doNotShowMud: true,
    doNotShowMorningCallUser: true,
    children: [
      {
        path: "inventoryDetails",
        name: "Missing Details",
        minicon: "animo-icons icon-mud-inventory",
        mini: "A",
        element: <InventoryDetails />,
        layout: "/admin",
        //doNotShowOperator: true,
        showOnlyThirds: true,
      },
      {
        path: "assets",
        name: "Assets",
        minicon: "animo-icons icon-collab-settings",
        mini: "A",
        element: <InventoryTable />,
        layout: "/admin",
        doNotShowOperator: true,
        doNotShowThirds: true,
      },
      {
        path: "shipments",
        name: "Shipments",
        minicon: "animo-icons icon-moving-truck",
        mini: "GS",
        element: <ShipTable />,
        layout: "/admin",
        doNotShowOperator: true,
        doNotShowThirds: true,
      },
      // {
      //   path: "/mwdshop",
      //   name: "MWD shop",
      //   mini: "MWD",
      //   element: <MWDShop/>,
      //   layout: "/admin",
      //   doNotShowOperator: true
      // },
      // {
      //   path: "/motorshop",
      //   name: "Motor shop",
      //   mini: "MTR",
      //   element: <MotorShop/>,
      //   layout: "/admin",
      //   doNotShowOperator: true
      // },
      // {
      //   path: "/mwdshop",
      //   name: "MWD Shop",
      //   mini: "MWD",
      //   element: <MWDShop/>,
      //   layout: "/admin",
      //   doNotShowOperator: true
      // },
    ],
  },

  {
    collapse: true,
    name: "Multi-Well",
    icon: "animo-icons icon-analysis",
    state: "dashCollapse",
    doNotShowThirds: true,
    doNotShow99: true,
    doNotShowMorningCallUser: true,
    children: [
      {
        path: "perfdash/:perftab",
        name: "KPI Analysis",
        minicon: "animo-icons icon-select-point",
        mini: "D2",
        element: <MultiWellPerformanceLayout />,
        layout: "/admin",
        doNotShow99: true,
      },
      {
        path: "perfdash",
        name: "KPI Analysis",
        minicon: "animo-icons icon-select-point",
        mini: "D2",
        element: <MultiWellPerformanceLayout />,
        layout: "/admin",
        doNotShow99: true,
      },
      {
        path: "rigRank/:rankTab",
        name: "Goal Results",
        minicon: "animo-icons icon-one-run",
        element: <GoalReviewLayout />,
        layout: "/admin",
        doNotShow99: true,
      },
      {
        path: "rigRank",
        name: "Goal Results",
        minicon: "animo-icons icon-one-run",
        element: <GoalReviewLayout />,
        layout: "/admin",
        doNotShow99: true,
      },
      {
        path: "rigPerformance",
        name: "Rig Performance",
        minicon: " animo-icons icon-drilling-rig-1",
        element: <RigPerformanceReport />,
        layout: "/admin",
        doNotShow99: true,
        // doNotShowOver1: true,
      },
      {
        path: "animoNexus",
        name: "Animo Nexus",
        minicon: "animo-icons icon-seamless-mind",
        element: <MultiWellSearch />,
        layout: "/admin",
        doNotShow99: true,
        doNotShowOver1: true,
      },
    ],
  },
  {
    collapse: true,
    name: "Operation MGMT",
    icon: "animo-icons icon-ops-dash-controls",
    state: "opsCollapse",
    doNotShowOver1: true,
    children: [
      {
        path: "opsdash/:viewId/:action",
        name: "Operation MGMT",
        minicon: "animo-icons icon-ops-dash-controls",
        mini: "OPS",
        element: <OpsLayout />,
        layout: "/admin",
        doNotShowOver1: true,
      },
      {
        path: "opsdash/:viewId",
        name: "Operation MGMT",
        minicon: "animo-icons icon-ops-dash-controls",
        mini: "OPS",
        element: <OpsLayout />,
        layout: "/admin",
        doNotShowOver1: true,
      },
      {
        path: "opsdash",
        name: "Operation MGMT",
        minicon: "animo-icons icon-ops-dash-controls",
        mini: "OPS",
        element: <OpsLayout />,
        layout: "/admin",
        doNotShowOver1: true,
      },
      {
        path: "dataqualityhub",
        name: "Data Quality",
        minicon: "animo-icons icon-data-validated",
        mini: "OPS",
        element: <OpsMonitoringHub />,
        layout: "/admin",
        doNotShowOver1: true,
      },
    ],
  },
  {
    path: "opsdash/:viewId/:action?",
    name: "Operation MGMT",
    icon: "animo-icons icon-ops-dash-controls",
    mini: "OPS",
    element: <OpsLayout />,
    layout: "/admin",
    doNotShowOver1: true,
  },
  {
    path: "opsdash/:viewId",
    name: "Operation MGMT",
    icon: "animo-icons icon-ops-dash-controls",
    mini: "OPS",
    element: <OpsLayout />,
    layout: "/admin",
    doNotShowOver1: true,
  },

  {
    path: "bids",
    name: "Pricing",
    icon: "tim-icons icon-coins",
    element: <BidTable />,
    layout: "/admin",
    doNotShowOperator: true,
    doNotShowThirds: true,
  },
  {
    path: "map",
    name: "Map",
    icon: "tim-icons icon-world",
    element: <GoogleMaps />,
    doNotShowThirds: true,
    // doNotShowOver4: true,
    doNotShow99: true,
    layout: "/admin",
  },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   icon: "tim-icons icon-alert-circle-exc",
  //   element: <AlertTable />,
  //   layout: "/admin",
  // },
  {
    name: "Engagement",
    icon: "tim-icons icon-controller",
    path: "engagement/:viewId?/:action?",
    element: <Engagement />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowThirds: true,
  },
  {
    name: "Engagement",
    icon: "tim-icons icon-controller",
    path: "engagement/:viewId?",
    element: <Engagement />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowThirds: true,
  },
  {
    name: "Engagement",
    icon: "tim-icons icon-controller",
    path: "engagement",
    element: <Engagement />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowThirds: true,
  },

  {
    path: "vowplanning",
    name: "VOW Planning",
    icon: "animo-icons icon-well-design",
    appAccessRequired: true,
    element: <VowPlanning />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "VOW Support",
    icon: "animo-icons icon-strategy",
    state: "PlanningCollapse",
    appAccessRequired: true,
    children: [
      {
        path: "eventScheduleLibrary",
        name: "Events Library",
        minicon: "animo-icons icon-report-details",
        appAccessRequired: true,
        element: <EventScheduleTables />,
        layout: "/admin",
      },
      {
        path: "scenarioLibrary",
        name: "Scenario Library",
        minicon: "animo-icons icon-algorithm",
        appAccessRequired: true,
        element: <ScenarioPlanningTables />,
        layout: "/admin",
      },
      {
        path: "afeLibrary",
        name: "AFE Library",
        minicon: "animo-icons icon-cost-breakdown",
        doNotShow99: true,
        element: <AFEPlanningTables />,
        appAccessRequired: true,
        layout: "/admin",
      },

      // {
      //   path: "businessPlanReview",
      //   name: "BP Vs Delivery",
      //   minicon: "animo-icons icon-forecast",
      //   appAccessRequired: true,
      //   element: <BusinessPlanLayout />,
      //   layout: "/admin",
      // },
      // {
      //   path: "eventLibrary",
      //   name: "Event Library",
      //   minicon: "animo-icons icon-ranked-segment",
      //   element: <EventPlanningTables />,
      //   appAccessRequired: true,
      //   layout: "/admin",
      // },
    ],
  },
  {
    collapse: true,
    name: "Management",
    icon: "tim-icons icon-notes",
    state: "Management",
    doNotShowThirds: true,
    doNotShowOver1: true,
    doNotShow99: true,
    doNotShowMorningCallUser: true,
    children: [
      {
        path: "addwell",
        name: "Add Well",
        minicon: "tim-icons icon-simple-add",
        mini: "Add",
        element: <AddWell />,
        doNotShowThirds: true,
        doNotShow99: true,
        doNotShowOver1: true,
        layout: "/admin",
      },
      {
        name: "Planning",
        state: "planning",
        minicon: "animo-icons icon-well-design",
        mini: "P",
        doNotShowThirds: true,
        doNotShow99: true,
        element: <Planning />,
        path: "planwell/:planTab?/:viewItemId?/:subTab?",
      },
      {
        path: "planwell/:planTab1//:viewItemId1//:subTab1/",
        name: "Planning",
        minicon: "animo-icons icon-well-design",
        mini: "P",
        element: <Planning />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },
      {
        path: "planwell/:planTab1//:viewItemId1/",
        name: "Planning",
        minicon: "animo-icons icon-well-design",
        mini: "P",
        element: <Planning />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },
      {
        path: "planwell/:planTab1/",
        name: "Planning",
        minicon: "animo-icons icon-well-design",
        mini: "P",
        element: <Planning />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },
      {
        path: "planwell",
        name: "Planning",
        minicon: "animo-icons icon-well-design",
        mini: "P",
        element: <Planning />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },

      {
        name: "Goals and KPIs",
        state: "planning",
        minicon: "animo-icons icon-sound-bars",
        mini: "P",
        doNotShowThirds: true,
        doNotShow99: true,
        element: <GoalLayout />,
        path: "goalmanagement/:planTab?/:viewItemId?/:subTab?",
      },
      {
        path: "goalmanagement/:planTab?/:viewItemId?/:subTab?",
        name: "Goals and KPIs",
        minicon: "animo-icons icon-sound-bars",
        mini: "P",
        element: <GoalLayout />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },
      {
        path: "goalmanagement/:planTab?/:viewItemId?",
        name: "Goals and KPIs",
        minicon: "animo-icons icon-sound-bars",
        mini: "P",
        element: <GoalLayout />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },
      {
        path: "goalmanagement/:planTab?",
        name: "Goals and KPIs",
        minicon: "animo-icons icon-sound-bars",
        mini: "P",
        element: <GoalLayout />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },
      {
        path: "goalmanagement",
        name: "Goals and KPIs",
        minicon: "animo-icons icon-sound-bars",
        mini: "P",
        element: <GoalLayout />,
        doNotShowThirds: true,
        doNotShow99: true,
        layout: "/admin",
      },

      {
        name: "System Details",
        minicon: "tim-icons icon-settings-gear-63 animo-icons-22",
        state: "AddInfo",
        layout: "/admin",
        path: "systemDetails",
        element: <CompanyManagement />,
        doNotShow99: true,
      },
      {
        name: "System Details",
        minicon: "tim-icons icon-settings-gear-63 animo-icons-22",
        state: "AddInfo",
        layout: "/admin",
        path: "systemDetails/:detailType",
        element: <CompanyManagement />,
        doNotShow99: true,
      },
      {
        name: "System Details",
        minicon: "tim-icons icon-settings-gear-63 animo-icons-22",
        state: "AddInfo",
        layout: "/admin",
        path: "systemDetails/:detailType/:detailId",
        element: <CompanyManagement />,
        doNotShow99: true,
      },
      // {
      //   collapse: true,
      //   name: "Review Data",
      //   state: "datatables",
      //   doNotShowThirds: true,
      //   doNotShow99: true,
      //   children: [
      //     {
      //       path: "bhatable",
      //       name: "BHA Table",
      //       mini: "BHA",
      //       element: <BHATable/>,
      //       doNotShow99: true,
      //       layout: "/admin"
      //     },
      //     {
      //       path: "goaltable",
      //       name: "Goal Table",
      //       mini: "Goal",
      //       element: <GoalTable/>,
      //       doNotShow99: true,
      //       layout: "/admin"
      //     },
      //     // {
      //     //   path: "/Intervaltable",
      //     //   name: "Interval Table",
      //     //   mini: "Int",
      //     //   element: <Development/>,
      //     //   layout: "/admin"
      //     // },
      //     {
      //       path: "editroadmaps",
      //       name: "RoadMaps",
      //       mini: "RM",
      //       element: <RoadMapTable/>,
      //       doNotShow99: true,
      //       layout: "/admin"
      //     },
      //   ]
      // },
      {
        name: "Users",
        minicon: "animo-icons icon-add-collab-group",
        state: "userprofiles",
        element: <UserManagement />,
        doNotShowThirds: true,
        doNotShowOver1: true,
        doNotShow99: true,
        layout: "/admin",
        path: "manageusers",
      },
      {
        name: "Users",
        minicon: "animo-icons icon-add-collab-group",
        state: "userprofiles",
        element: <UserManagement />,
        doNotShowThirds: true,
        doNotShowOver1: true,
        doNotShow99: true,
        layout: "/admin",
        path: "manageusers/:accessType",
      },
      {
        name: "Users",
        minicon: "animo-icons icon-add-collab-group",
        state: "userprofiles",
        element: <UserManagement />,
        doNotShowThirds: true,
        doNotShowOver1: true,
        doNotShow99: true,
        layout: "/admin",
        path: "manageusers/:accessType/:accessId",
      },
    ],
  },

  // {
  //   path: "/help/:viewId/:tabId",
  //   name: "Help",
  //   icon: "animo-icons icon-video-player",
  //   element: <Help/>,
  //   doNotShow99: true,
  //   layout: "/admin"
  // },
  // {
  //   path: "/help/:viewId",
  //   name: "Help",
  //   icon: "animo-icons icon-video-player",
  //   element: <Help/>,
  //   doNotShow99: true,
  //   layout: "/admin"
  // },
  // {
  //   path: "/help",
  //   name: "Help",
  //   icon: "animo-icons icon-video-player",
  //   element: <Help/>,
  //   doNotShow99: true,
  //   layout: "/admin"
  // },

  {
    path: "editbid/:bidid",
    //name: "edit Bid",
    //mini: "Eb",
    element: <EditBid />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "editbid",
    //name: "edit Bid",
    //mini: "Eb",
    element: <EditBid />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "addpersonjob",
    //name: "Add Person Job",
    //mini: "Ap",
    element: <AddPersonJob />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "addshipment",
    //name: "Add Shipment",
    //mini: "sh",
    element: <AddShip />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "editship",
    //name: "Add Shipment",
    //mini: "sh",
    element: <EditShip />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "addinventory",
    //name: "Add inventory",
    //mini: "sh",
    element: <AddInventory />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "wellinfo/AddBHA",
    //name: "Build BHA",
    // mini: "Mi",
    element: <AddBHA />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "addbid",
    //name: "Add Bid Item",
    // mini: "Mi",
    element: <AddBid />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "Intervaltable",
    //name: "Interval Table",
    // mini: "R",
    element: <IntervalTable />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "bhatable",
    //name: "bha Table",
    //mini: "R",
    element: <BHATable />,
    layout: "/admin",
    doNotShowInSideber: true,
  },

  {
    path: "login",
    name: "",
    //mini: "L",
    element: <Login />,
    layout: "/auth",
    doNotShowInSideber: true,
  },

  {
    path: "resetpassword/:token",
    //mini: "L",
    element: <ChangePassword />,
    layout: "/auth",
    doNotShowInSideber: true,
  },
  {
    path: "resetpassword",
    //mini: "L",
    element: <ChangePassword />,
    layout: "/auth",
    doNotShowInSideber: true,
  },
  {
    path: "changepassword",
    name: "Change Password",
    //mini: "L",
    element: <ChangePassword />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "feedback",
    name: "Work In Progress",
    //mini: "R",
    element: <Development />,
    layout: "/auth",
    doNotShowInSideber: true,
  },
  {
    path: "lock-screen",
    name: "Lock Screen",
    //mini: "LS",
    element: <Lock />,
    layout: "/auth",
    doNotShowInSideber: true,
  },
  {
    path: "userProfile",
    name: "User Profile",
    //mini: "u",
    element: <UserProfile />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "fileupload",
    //name: "FileUpload",
    //mini: "u",
    element: <PlanUpload />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "directional",
    //name: "Directional",
    //mini: "u",
    element: <Directional />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "editbha",
    name: "BHA Edit",
    element: <EditBHA />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  // {
  //   path: "/buildbha",
  //   //name: "Build BHA",
  //   //mini: "Mi",
  //   element: <BHAbuild/>,
  //   layout: "/admin",
  //   doNotShowInSideber: true
  // },
  {
    path: "wellplot",
    //name: "WellPlot",
    //mini: "wp",
    element: <WellPlots />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "listadd",
    //name: "Add to List",
    //mini: "Mi",
    element: <Listadd />,
    layout: "/admin",
    doNotShowInSideber: true,
  },

  // {
  //   path: "/dualfilter",
  //   name: "Filtered List",
  //   mini: "Mi",
  //   element: <DualFilter/>,
  //   layout: "/admin"
  // },
  {
    path: "feedback",
    element: <Development />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "error",
    name: "Error Page",
    element: <Error />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "vendorassets",
    element: <EditVendorInventory />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "editassets",
    element: <EditInventory />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "editwell/:wellid",
    element: <EditWell />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "editwell",
    element: <EditWell />,
    layout: "/admin",
    doNotShowInSideber: true,
  },

  {
    path: "inventoryDetails",
    name: "Missing Details",
    minicon: "animo-icons icon-mud-inventory",
    mini: "A",
    element: <InventoryDetails />,
    layout: "/admin",
    //doNotShowOperator: true,
    showOnlyThirds: true,
    doNotShowInSideber: true,
  },
  {
    path: "assets",
    name: "Assets",
    minicon: "animo-icons icon-collab-settings",
    mini: "A",
    element: <InventoryTable />,
    layout: "/admin",
    doNotShowOperator: true,
    doNotShowThirds: true,
    doNotShowInSideber: true,
  },
  {
    path: "shipments",
    name: "Shipments",
    minicon: "animo-icons icon-moving-truck",
    mini: "GS",
    element: <ShipTable />,
    layout: "/admin",
    doNotShowOperator: true,
    doNotShowThirds: true,
    doNotShowInSideber: true,
  },
  {
    name: "Goals and KPIs",
    state: "planning",
    minicon: "animo-icons icon-sound-bars",
    mini: "P",
    doNotShowThirds: true,
    doNotShowInSideber: true,
    doNotShow99: true,
    element: <GoalLayout />,
    path: "goalmanagement/:planTab?/:viewItemId?/:subTab?",
  },
  {
    path: "goalmanagement/:planTab?/:viewItemId?/:subTab?",
    name: "Goals and KPIs",
    minicon: "animo-icons icon-sound-bars",
    mini: "P",
    element: <GoalLayout />,
    doNotShowThirds: true,
    doNotShowInSideber: true,
    doNotShow99: true,
    layout: "/admin",
  },
  {
    path: "goalmanagement/:planTab?/:viewItemId?",
    name: "Goals and KPIs",
    minicon: "animo-icons icon-sound-bars",
    mini: "P",
    element: <GoalLayout />,
    doNotShowThirds: true,
    doNotShowInSideber: true,
    doNotShow99: true,
    layout: "/admin",
  },
  {
    path: "goalmanagement/:planTab?",
    name: "Goals and KPIs",
    minicon: "animo-icons icon-sound-bars",
    mini: "P",
    element: <GoalLayout />,
    doNotShowThirds: true,
    doNotShowInSideber: true,
    doNotShow99: true,
    layout: "/admin",
  },
  {
    path: "goalmanagement",
    name: "Goals and KPIs",
    minicon: "animo-icons icon-sound-bars",
    mini: "P",
    element: <GoalLayout />,
    doNotShowThirds: true,
    doNotShowInSideber: true,
    doNotShow99: true,
    layout: "/admin",
  },

  {
    path: "perfdash/:perftab",
    name: "Analyze",
    minicon: "animo-icons icon-select-point",
    mini: "D2",
    element: <MultiWellPerformanceLayout />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowInSideber: true,
  },
  {
    path: "perfdash",
    name: "Analyze",
    minicon: "animo-icons icon-select-point",
    mini: "D2",
    element: <MultiWellPerformanceLayout />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowInSideber: true,
  },

  {
    path: "rigRank/:rankTab",
    name: "Rig Ranking",
    minicon: "animo-icons icon-one-run",
    element: <GoalReviewLayout />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowInSideber: true,
  },
  {
    path: "animoNexus",
    name: "Animo Nexus",
    minicon: "animo-icons icon-seamless-mind",
    element: <MultiWellSearch />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowInSideber: true,
    doNotShowOver1: true,
  },
  {
    path: "rigPerformance",
    name: "Rig Performance",
    minicon: "animo-icons icon-drilling-rig-1",
    element: <RigPerformanceReport />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowInSideber: true,
    doNotShowOver1: true,
  },
  {
    path: "rigRank",
    name: "Rig Ranking",
    minicon: "animo-icons icon-one-run",
    element: <GoalReviewLayout />,
    layout: "/admin",
    doNotShow99: true,
    doNotShowInSideber: true,
  },

  {
    path: "addwell",
    name: "Add Well",
    minicon: "tim-icons icon-simple-add",
    mini: "Add",
    element: <AddWell />,
    doNotShowThirds: true,
    doNotShow99: true,
    doNotShowOver1: true,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    name: "Planning",
    state: "planning",
    minicon: "animo-icons icon-well-design",
    mini: "P",
    doNotShowThirds: true,
    doNotShow99: true,
    element: <Planning />,
    path: "planwell/:planTab?/:viewItemId?/:subTab?",
    doNotShowInSideber: true,
  },
  {
    path: "planwell/:planTab1//:viewItemId1//:subTab1/",
    name: "Planning",
    minicon: "animo-icons icon-well-design",
    mini: "P",
    element: <Planning />,
    doNotShowThirds: true,
    doNotShow99: true,
    layout: "/admin",
    doNotShowInSideber: false,
  },
  {
    path: "planwell/:planTab1//:viewItemId1/",
    name: "Planning",
    minicon: "animo-icons icon-well-design",
    mini: "P",
    element: <Planning />,
    doNotShowThirds: true,
    doNotShow99: true,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "planwell/:planTab1/",
    name: "Planning",
    minicon: "animo-icons icon-well-design",
    mini: "P",
    element: <Planning />,
    doNotShowThirds: true,
    doNotShow99: true,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "planwell",
    name: "Planning",
    minicon: "animo-icons icon-well-design",
    mini: "P",
    element: <Planning />,
    doNotShowThirds: true,
    doNotShow99: true,
    layout: "/admin",
    doNotShowInSideber: true,
  },

  {
    name: "System Details",
    minicon: "tim-icons icon-settings-gear-63 animo-icons-22",
    state: "AddInfo",
    layout: "/admin",
    path: "systemDetails",
    element: <CompanyManagement />,
    doNotShow99: true,
    doNotShowInSideber: true,
  },
  {
    name: "System Details",
    minicon: "tim-icons icon-settings-gear-63 animo-icons-22",
    state: "AddInfo",
    layout: "/admin",
    path: "systemDetails/:detailType",
    element: <CompanyManagement />,
    doNotShow99: true,
    doNotShowInSideber: true,
  },
  {
    name: "System Details",
    minicon: "tim-icons icon-settings-gear-63 animo-icons-22",
    state: "AddInfo",
    layout: "/admin",
    path: "systemDetails/:detailType/:detailId",
    element: <CompanyManagement />,
    doNotShow99: true,
    doNotShowInSideber: true,
  },
  {
    name: "Users",
    minicon: "animo-icons icon-add-collab-group",
    state: "userprofiles",
    element: <UserManagement />,
    doNotShowThirds: true,
    doNotShowOver1: true,
    doNotShow99: true,
    layout: "/admin",
    path: "manageusers",
    doNotShowInSideber: true,
  },
  {
    name: "Users",
    minicon: "animo-icons icon-add-collab-group",
    state: "userprofiles",
    element: <UserManagement />,
    doNotShowThirds: true,
    doNotShowOver1: true,
    doNotShow99: true,
    layout: "/admin",
    path: "manageusers/:accessType",
    doNotShowInSideber: true,
  },
  {
    name: "Users",
    minicon: "animo-icons icon-add-collab-group",
    state: "userprofiles",
    element: <UserManagement />,
    doNotShowThirds: true,
    doNotShowOver1: true,
    doNotShow99: true,
    layout: "/admin",
    path: "manageusers/:accessType/:accessId",
    doNotShowInSideber: true,
  },

  {
    path: "opsdash/:viewId/:action",
    name: "Operation MGMT",
    minicon: "animo-icons icon-ops-dash-controls",
    mini: "OPS",
    element: <OpsLayout />,
    layout: "/admin",
    doNotShowOver1: true,
    doNotShowInSideber: true,
  },
  {
    path: "opsdash/:viewId",
    name: "Operation MGMT",
    minicon: "animo-icons icon-ops-dash-controls",
    mini: "OPS",
    element: <OpsLayout />,
    layout: "/admin",
    doNotShowOver1: true,
    doNotShowInSideber: true,
  },
  {
    path: "opsdash",
    name: "Operation MGMT",
    minicon: "animo-icons icon-ops-dash-controls",
    mini: "OPS",
    element: <OpsLayout />,
    layout: "/admin",
    doNotShowOver1: true,
    doNotShowInSideber: true,
  },
  {
    path: "dataqualityhub/:viewId/:actionId",
    name: "Data Quality",
    minicon: "animo-icons icon-data-validated",
    mini: "OPS",
    element: <OpsMonitoringHub />,
    layout: "/admin",
    doNotShowOver1: true,
    doNotShowInSideber: true,
  },
  {
    path: "dataqualityhub/:viewId",
    name: "Data Quality",
    minicon: "animo-icons icon-data-validated",
    mini: "OPS",
    element: <OpsMonitoringHub />,
    layout: "/admin",
    doNotShowOver1: true,
    doNotShowInSideber: true,
  },
  {
    path: "dataqualityhub",
    name: "Data Quality",
    minicon: "animo-icons icon-data-validated",
    mini: "OPS",
    element: <OpsMonitoringHub />,
    layout: "/admin",
    doNotShowOver1: true,
    doNotShowInSideber: true,
  },
  {
    path: "animoWellViewer",
    name: "RTViewer",
    minicon: "animo-icons icon-incident-report",
    element: <RTFullScreen />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "animoWellViewer/:wellid",
    name: "RTViewer",
    minicon: "animo-icons icon-incident-report",
    element: <RTFullScreen />,
    layout: "/popOut",
    doNotShowInSideber: true,
  },

  {
    path: "digitalHub/:wellid/:wellFunction?/:welltab?/:subcat?/:subcatid?/:action?/:actionid?",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "digitalHub/:wellid/:wellFunction?/:welltab?/:subcat?/:subcatid?/:action?",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "digitalHub/:wellid/:wellFunction?/:welltab?/:subcat?/:subcatid?",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "digitalHub/:wellid/:wellFunction?/:welltab?/:subcat?",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "digitalHub/:wellid/:wellFunction?/:welltab?",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "digitalHub/:wellid/:wellFunction?",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "digitalHub/:wellid",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "digitalHub",
    name: "Digital Hub",
    minicon: "animo-icons icon-blockchain",
    element: <DigitalHubLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "userNotifications",
    name: "Notifications",
    minicon: "animo-icons icon-blockchain",
    element: <UserNotifications />,
    layout: "/admin",
    NeedActiveJob: false,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell/:wellid/:wellFunction?/:welltab?/:subcat?/:subcatid?/:action?/:actionid?",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell/:wellid/:wellFunction?/:welltab?/:subcat?/:subcatid?/:action?",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell/:wellid/:wellFunction?/:welltab?/:subcat?/:subcatid?",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell/:wellid/:wellFunction?/:welltab?/:subcat?",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell/:wellid/:wellFunction?/:welltab?",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell/:wellid/:wellFunction?",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell/:wellid",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "activewell",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },

  {
    path: "activewell",
    name: "Well Analytics",
    minicon: "animo-icons icon-segment-results",
    element: <DrillingLayout />,
    layout: "/admin",
    NeedActiveJob: true,
    doNotShowMorningCallUser: true,
    doNotShowInSideber: true,
  },
  {
    path: "eventScheduleLibrary",
    name: "Events Library",
    minicon: "animo-icons icon-report-details",
    appAccessRequired: true,
    element: <EventScheduleTables />,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "scenarioLibrary",
    name: "Scenario Library",
    minicon: "animo-icons icon-algorithm",
    element: <ScenarioPlanningTables />,
    appAccessRequired: true,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "afeLibrary",
    name: "AFE Library",
    minicon: "animo-icons icon-cost-breakdown",
    doNotShow99: true,
    element: <AFEPlanningTables />,
    appAccessRequired: true,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "eventLibrary",
    name: "Event Library",
    minicon: "animo-icons icon-ranked-segment",
    element: <EventPlanningTables />,
    appAccessRequired: true,
    layout: "/admin",
    doNotShowInSideber: true,
  },
  {
    path: "businessPlanReview",
    name: "BP Vs Delivery",
    minicon: "animo-icons icon-forecast",
    appAccessRequired: true,
    element: <BusinessPlanLayout />,
    layout: "/admin",
  },
];

export default routes;
